import { animes } from "@/mocks/animes";

const pickIds = ["summer-friend", "tonari-totoro", "barakamon"];

export default function PickSection() {
  const picks = pickIds
    .map((id) => animes.find((a) => a.id === id))
    .filter((a): a is (typeof animes)[number] => Boolean(a));

  return (
    <section id="pick" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="mb-8 flex flex-col gap-2 md:mb-10 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
            编辑精选
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            治愈番剧精选
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            不知道从哪一部开始？这三部闭眼入，暖到骨子里。
          </p>
        </div>
        <a
          href="#list"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          查看全部片单 <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {picks.map((a) => (
          <article
            key={a.id}
            className="group overflow-hidden rounded-lg bg-background-100 border border-background-200/70"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={a.image}
                alt={`${a.title} 治愈系番剧封面`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                {a.rating} 分
              </span>
              <span className="absolute right-3 top-3 rounded-full bg-foreground-950/50 px-3 py-1 text-xs text-background-50 backdrop-blur">
                {a.status}
              </span>
            </div>
            <div className="p-5">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading text-lg text-foreground-950">{a.title}</h3>
                <span className="whitespace-nowrap text-xs text-foreground-500">{a.episodes}</span>
              </div>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {a.summary}
              </p>
              <p className="mt-3 inline-flex items-center gap-1 text-sm text-accent-700">
                <i className="ri-quill-pen-line"></i> {a.highlights}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}